import { DGNBPassportIN, dgnbApi, getLocalAuthHeader } from "api-client";

export default async function handleDgnbPassportGetLatest(
  buildingId: string
): Promise<DGNBPassportIN> {
  const localAuthHeader = getLocalAuthHeader();
  try {
    const response = await dgnbApi.reportApiV1RoutersDgnbPassportLatest(
      buildingId,
      localAuthHeader
    );
    return {
      ...response.data[0]?.input_data,
      // A change in the schema forces us to nullify always this 2 values
      gwp_b6: null,
      penrt_b6: null,
    };
  } catch (e) {
    console.error("Failed to fetch latest DGNB Passport", e, buildingId);
  }
  return {} as DGNBPassportIN;
}
